import { crabDevice } from '@hfzq/crab-utils';
import React, { FC } from 'react';
import classNames from 'classnames';
import { SCALE_CONFIG } from '@src/helper/hooks/use-cancle-scale';
import styles from './index.module.less';

type InsetProps = React.HTMLProps<HTMLDivElement>;

export const BottomInset: FC<InsetProps> = ({ className, style, ...props }) => (
  <div
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    style={{ '--scale-safe-area-multiple': SCALE_CONFIG.cancel ? 1 : getDpr(), ...style } as any}
    className={classNames(styles.bottomInset, className)}
    {...props}
  />
);

export const TopInset: FC<InsetProps> = ({ className, style, ...props }) => {
  if (crabDevice.isTZT) {
    return (
      <div
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        style={{ '--scale-safe-area-multiple': SCALE_CONFIG.cancel ? 1 : getDpr(), ...style } as any}
        className={classNames(
          { [styles.iosTopInset]: crabDevice.isIOS, [styles.androidTopInset]: crabDevice.isAndroid },
          className
        )}
        {...props}
      />
    );
  }
  return null;
};

const getDpr = () => {
  let dpr = 1;
  const viewport = document.querySelector('meta[name="viewport"]');
  // 解析 viewport 的 initial-scale
  if (viewport) {
    const match = viewport.getAttribute('content')?.match(/initial-scale=([\d.]+)/);
    if (match) {
      dpr = 1 / parseFloat(match[1]);
    }
  }
  return dpr;
};
